












































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { DatasetGroup } from "@/views/aivnplan/types";
import { Dataset, DefaultDataset } from "#/model/admin/dataset";
import RulesMixin from "#/mixins/rulesMixin";
import { VForm } from "@/types";

@Component
/**
 * データセット一覧
 */
export default class DatasetForm extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** Ref */

  /** フォーム操作用 */
  @Ref("form") private readonly form!: VForm;

  /** 変数 */

  /** データセット */
  private dataset: Dataset = DefaultDataset();

  /** データセットグループ・項目 */
  private datasetGroups: DatasetGroup[] = [];

  /** 遷移元画面タイプ 1:インデックス作成 2:インデックス自動作成条件設定 */
  private fromType = 0;

  /** 関数 */

  created() {
    this.fromType = Number(this.$route.query.fromType as string);
    this.fetch();
  }

  /** 取得 */
  private fetch() {
    const datasetId = Number(this.$route.params.id);

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/dataset/get",
      { id: datasetId },
      async (res) => {
        this.dataset = res.data.dataset;
        this.datasetGroups = res.data.groups;
      }
    );
  }

  /** 保存 */
  private async save() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }
    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/dataset/save",
      { dataset: this.dataset, groups: this.datasetGroups },
      async () => {
        this.moveToIndexPage();
      }
    );
  }

  /** 削除 */
  private async deleteDataset() {
    if (!(await this.$openConfirm("削除します。よろしいですか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/dataset/delete",
      { dataset: this.dataset },
      async () => {
        this.moveToIndexPage();
      }
    );
  }

  /** キャンセル */
  private cancel() {
    this.moveToIndexPage();
  }

  /** データセットバリデーションチェック */
  private checkDatasetGroup(): boolean | string {
    const checkedIndex = this.datasetGroups.findIndex(
      (datasetGroup: DatasetGroup) => {
        return (
          datasetGroup.items.findIndex(
            (datasetItem) => datasetItem.is_checked === true
          ) !== -1
        );
      }
    );

    if (checkedIndex === -1) {
      return "最低1つはチェックを入れてください。";
    }

    return true;
  }

  /** インデックス作成/自動作成条件設定画面に戻る */
  private moveToIndexPage() {
    this.$router.push({
      path: `/ai-vnplan/index/${
        this.fromType == 1 ? "create" : "batch-config"
      }`,
    });
  }
}
